import { render, staticRenderFns } from "./Theatre.vue?vue&type=template&id=ce0185bc&"
import script from "./Theatre.vue?vue&type=script&lang=js&"
export * from "./Theatre.vue?vue&type=script&lang=js&"
import style0 from "./Theatre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports